// tslint:disable-next-line:eofline
export * from './login.component';


// WEBPACK FOOTER //
// ./src/app/login/index.ts